
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_31816_10882)","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.683 2.817A4.78 4.78 0 006 2.5a5 5 0 105 5","stroke":"#494949","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M13 1.5L6 8.889 3.667 6.556","stroke":"#DD8500","stroke-width":"2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_31816_10882"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    